/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SelectField,
  TextField,
} from "@aws-amplify/ui-react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { UserProfile } from "../models";
import { fetchByPath, validateField } from "./utils";
import { DataStore } from "aws-amplify";
export default function UserProfileUpdateForm(props) {
  const {
    id: idProp,
    userProfile: userProfileModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    email: "",
    name: "",
    dob: "",
    gender: "",
    height: "",
    company: "",
    mobile: "",
    dietstatus: "",
    diet: "",
    ptstatus: "",
    selfishsstatus: "",
    profile: "",
    breakfast: "",
    lunch: "",
    esnacks: "",
    dinner: "",
    dietaryadvice: "",
    plan: "",
    diettype: "",
  };
  const [email, setEmail] = React.useState(initialValues.email);
  const [name, setName] = React.useState(initialValues.name);
  const [dob, setDob] = React.useState(initialValues.dob);
  const [gender, setGender] = React.useState(initialValues.gender);
  const [height, setHeight] = React.useState(initialValues.height);
  const [company, setCompany] = React.useState(initialValues.company);
  const [mobile, setMobile] = React.useState(initialValues.mobile);
  const [dietstatus, setDietstatus] = React.useState(initialValues.dietstatus);
  const [diet, setDiet] = React.useState(initialValues.diet);
  const [ptstatus, setPtstatus] = React.useState(initialValues.ptstatus);
  const [selfishsstatus, setSelfishsstatus] = React.useState(
    initialValues.selfishsstatus
  );
  const [profile, setProfile] = React.useState(initialValues.profile);
  const [breakfast, setBreakfast] = React.useState(initialValues.breakfast);
  const [lunch, setLunch] = React.useState(initialValues.lunch);
  const [esnacks, setEsnacks] = React.useState(initialValues.esnacks);
  const [dinner, setDinner] = React.useState(initialValues.dinner);
  const [dietaryadvice, setDietaryadvice] = React.useState(
    initialValues.dietaryadvice
  );
  const [plan, setPlan] = React.useState(initialValues.plan);
  const [diettype, setDiettype] = React.useState(initialValues.diettype);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = userProfileRecord
      ? { ...initialValues, ...userProfileRecord }
      : initialValues;
    setEmail(cleanValues.email);
    setName(cleanValues.name);
    setDob(cleanValues.dob);
    setGender(cleanValues.gender);
    setHeight(cleanValues.height);
    setCompany(cleanValues.company);
    setMobile(cleanValues.mobile);
    setDietstatus(cleanValues.dietstatus);
    setDiet(cleanValues.diet);
    setPtstatus(cleanValues.ptstatus);
    setSelfishsstatus(cleanValues.selfishsstatus);
    setProfile(cleanValues.profile);
    setBreakfast(cleanValues.breakfast);
    setLunch(cleanValues.lunch);
    setEsnacks(cleanValues.esnacks);
    setDinner(cleanValues.dinner);
    setDietaryadvice(cleanValues.dietaryadvice);
    setPlan(cleanValues.plan);
    setDiettype(cleanValues.diettype);
    setErrors({});
  };
  const [userProfileRecord, setUserProfileRecord] =
    React.useState(userProfileModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? await DataStore.query(UserProfile, idProp)
        : userProfileModelProp;
      setUserProfileRecord(record);
    };
    queryData();
  }, [idProp, userProfileModelProp]);
  React.useEffect(resetStateValues, [userProfileRecord]);
  const validations = {
    email: [{ type: "Required" }],
    name: [{ type: "Required" }],
    dob: [{ type: "Required" }],
    gender: [],
    height: [{ type: "Required" }],
    company: [{ type: "Required" }],
    mobile: [],
    dietstatus: [],
    diet: [],
    ptstatus: [],
    selfishsstatus: [],
    profile: [],
    breakfast: [],
    lunch: [],
    esnacks: [],
    dinner: [],
    dietaryadvice: [],
    plan: [],
    diettype: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          email,
          name,
          dob,
          gender,
          height,
          company,
          mobile,
          dietstatus,
          diet,
          ptstatus,
          selfishsstatus,
          profile,
          breakfast,
          lunch,
          esnacks,
          dinner,
          dietaryadvice,
          plan,
          diettype,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value.trim() === "") {
              modelFields[key] = undefined;
            }
          });
          await DataStore.save(
            UserProfile.copyOf(userProfileRecord, (updated) => {
              Object.assign(updated, modelFields);
            })
          );
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}
      {...getOverrideProps(overrides, "UserProfileUpdateForm")}
      {...rest}
    >
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Email</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isDisabled={true}
        isReadOnly={true}
        value={email}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email: value,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.email ?? value;
          }
          if (errors.email?.hasError) {
            runValidationTasks("email", value);
          }
          setEmail(value);
        }}
        onBlur={() => runValidationTasks("email", email)}
        errorMessage={errors.email?.errorMessage}
        hasError={errors.email?.hasError}
        {...getOverrideProps(overrides, "email")}
      ></TextField>
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Name</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        value={name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name: value,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.name ?? value;
          }
          if (errors.name?.hasError) {
            runValidationTasks("name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("name", name)}
        errorMessage={errors.name?.errorMessage}
        hasError={errors.name?.hasError}
        {...getOverrideProps(overrides, "name")}
      ></TextField>
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Dob</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        type="date"
        value={dob}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob: value,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.dob ?? value;
          }
          if (errors.dob?.hasError) {
            runValidationTasks("dob", value);
          }
          setDob(value);
        }}
        onBlur={() => runValidationTasks("dob", dob)}
        errorMessage={errors.dob?.errorMessage}
        hasError={errors.dob?.hasError}
        {...getOverrideProps(overrides, "dob")}
      ></TextField>
      <SelectField
        label="Gender"
        placeholder="Please select an option"
        isDisabled={false}
        value={gender}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender: value,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.gender ?? value;
          }
          if (errors.gender?.hasError) {
            runValidationTasks("gender", value);
          }
          setGender(value);
        }}
        onBlur={() => runValidationTasks("gender", gender)}
        errorMessage={errors.gender?.errorMessage}
        hasError={errors.gender?.hasError}
        {...getOverrideProps(overrides, "gender")}
      >
        <option
          children="Male"
          value="MALE"
          {...getOverrideProps(overrides, "genderoption0")}
        ></option>
        <option
          children="Female"
          value="FEMALE"
          {...getOverrideProps(overrides, "genderoption1")}
        ></option>
      </SelectField>
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Height</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isReadOnly={false}
        value={height}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height: value,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.height ?? value;
          }
          if (errors.height?.hasError) {
            runValidationTasks("height", value);
          }
          setHeight(value);
        }}
        onBlur={() => runValidationTasks("height", height)}
        errorMessage={errors.height?.errorMessage}
        hasError={errors.height?.hasError}
        {...getOverrideProps(overrides, "height")}
      ></TextField>
      <TextField
        label={
          <span style={{ display: "inline-flex" }}>
            <span>Company</span>
            <span style={{ color: "red" }}>*</span>
          </span>
        }
        isRequired={true}
        isReadOnly={true}
        value={company}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company: value,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.company ?? value;
          }
          if (errors.company?.hasError) {
            runValidationTasks("company", value);
          }
          setCompany(value);
        }}
        onBlur={() => runValidationTasks("company", company)}
        errorMessage={errors.company?.errorMessage}
        hasError={errors.company?.hasError}
        {...getOverrideProps(overrides, "company")}
      ></TextField>
      <TextField
        label="Mobile"
        isRequired={false}
        isReadOnly={false}
        value={mobile}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile: value,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.mobile ?? value;
          }
          if (errors.mobile?.hasError) {
            runValidationTasks("mobile", value);
          }
          setMobile(value);
        }}
        onBlur={() => runValidationTasks("mobile", mobile)}
        errorMessage={errors.mobile?.errorMessage}
        hasError={errors.mobile?.hasError}
        {...getOverrideProps(overrides, "mobile")}
      ></TextField>
      <SelectField
        label="Dietstatus"
        placeholder="Please select an option"
        isDisabled={false}
        value={dietstatus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus: value,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.dietstatus ?? value;
          }
          if (errors.dietstatus?.hasError) {
            runValidationTasks("dietstatus", value);
          }
          setDietstatus(value);
        }}
        onBlur={() => runValidationTasks("dietstatus", dietstatus)}
        errorMessage={errors.dietstatus?.errorMessage}
        hasError={errors.dietstatus?.hasError}
        {...getOverrideProps(overrides, "dietstatus")}
      >
        <option
          children="Active"
          value="ACTIVE"
          {...getOverrideProps(overrides, "dietstatusoption0")}
        ></option>
        <option
          children="Inactive"
          value="INACTIVE"
          {...getOverrideProps(overrides, "dietstatusoption1")}
        ></option>
      </SelectField>
      <TextField
        label="Diet"
        isRequired={false}
        isReadOnly={false}
        value={diet}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet: value,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.diet ?? value;
          }
          if (errors.diet?.hasError) {
            runValidationTasks("diet", value);
          }
          setDiet(value);
        }}
        onBlur={() => runValidationTasks("diet", diet)}
        errorMessage={errors.diet?.errorMessage}
        hasError={errors.diet?.hasError}
        {...getOverrideProps(overrides, "diet")}
      ></TextField>
      <SelectField
        label="Ptstatus"
        placeholder="Please select an option"
        isDisabled={false}
        value={ptstatus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus: value,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.ptstatus ?? value;
          }
          if (errors.ptstatus?.hasError) {
            runValidationTasks("ptstatus", value);
          }
          setPtstatus(value);
        }}
        onBlur={() => runValidationTasks("ptstatus", ptstatus)}
        errorMessage={errors.ptstatus?.errorMessage}
        hasError={errors.ptstatus?.hasError}
        {...getOverrideProps(overrides, "ptstatus")}
      >
        <option
          children="Active"
          value="ACTIVE"
          {...getOverrideProps(overrides, "ptstatusoption0")}
        ></option>
        <option
          children="Inactive"
          value="INACTIVE"
          {...getOverrideProps(overrides, "ptstatusoption1")}
        ></option>
      </SelectField>
      <SelectField
        label="Selfishsstatus"
        placeholder="Please select an option"
        isDisabled={false}
        value={selfishsstatus}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus: value,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.selfishsstatus ?? value;
          }
          if (errors.selfishsstatus?.hasError) {
            runValidationTasks("selfishsstatus", value);
          }
          setSelfishsstatus(value);
        }}
        onBlur={() => runValidationTasks("selfishsstatus", selfishsstatus)}
        errorMessage={errors.selfishsstatus?.errorMessage}
        hasError={errors.selfishsstatus?.hasError}
        {...getOverrideProps(overrides, "selfishsstatus")}
      >
        <option
          children="Active"
          value="ACTIVE"
          {...getOverrideProps(overrides, "selfishsstatusoption0")}
        ></option>
        <option
          children="Inactive"
          value="INACTIVE"
          {...getOverrideProps(overrides, "selfishsstatusoption1")}
        ></option>
      </SelectField>
      <SelectField
        label="Profile"
        placeholder="Please select an option"
        isDisabled={true}
        isReadOnly={true}
        value={profile}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile: value,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.profile ?? value;
          }
          if (errors.profile?.hasError) {
            runValidationTasks("profile", value);
          }
          setProfile(value);
        }}
        onBlur={() => runValidationTasks("profile", profile)}
        errorMessage={errors.profile?.errorMessage}
        hasError={errors.profile?.hasError}
        {...getOverrideProps(overrides, "profile")}
      >
        <option
          children="Active"
          value="ACTIVE"
          {...getOverrideProps(overrides, "profileoption0")}
        ></option>
        <option
          children="Inactive"
          value="INACTIVE"
          {...getOverrideProps(overrides, "profileoption1")}
        ></option>
      </SelectField>
      <TextField
        label="Breakfast"
        isRequired={false}
        isReadOnly={false}
        value={breakfast}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast: value,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.breakfast ?? value;
          }
          if (errors.breakfast?.hasError) {
            runValidationTasks("breakfast", value);
          }
          setBreakfast(value);
        }}
        onBlur={() => runValidationTasks("breakfast", breakfast)}
        errorMessage={errors.breakfast?.errorMessage}
        hasError={errors.breakfast?.hasError}
        {...getOverrideProps(overrides, "breakfast")}
      ></TextField>
      <TextField
        label="Lunch"
        isRequired={false}
        isReadOnly={false}
        value={lunch}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch: value,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.lunch ?? value;
          }
          if (errors.lunch?.hasError) {
            runValidationTasks("lunch", value);
          }
          setLunch(value);
        }}
        onBlur={() => runValidationTasks("lunch", lunch)}
        errorMessage={errors.lunch?.errorMessage}
        hasError={errors.lunch?.hasError}
        {...getOverrideProps(overrides, "lunch")}
      ></TextField>
      <TextField
        label="Esnacks"
        isRequired={false}
        isReadOnly={false}
        value={esnacks}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks: value,
              dinner,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.esnacks ?? value;
          }
          if (errors.esnacks?.hasError) {
            runValidationTasks("esnacks", value);
          }
          setEsnacks(value);
        }}
        onBlur={() => runValidationTasks("esnacks", esnacks)}
        errorMessage={errors.esnacks?.errorMessage}
        hasError={errors.esnacks?.hasError}
        {...getOverrideProps(overrides, "esnacks")}
      ></TextField>
      <TextField
        label="Dinner"
        isRequired={false}
        isReadOnly={false}
        value={dinner}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner: value,
              dietaryadvice,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.dinner ?? value;
          }
          if (errors.dinner?.hasError) {
            runValidationTasks("dinner", value);
          }
          setDinner(value);
        }}
        onBlur={() => runValidationTasks("dinner", dinner)}
        errorMessage={errors.dinner?.errorMessage}
        hasError={errors.dinner?.hasError}
        {...getOverrideProps(overrides, "dinner")}
      ></TextField>
      <TextField
        label="Dietaryadvice"
        isRequired={false}
        isReadOnly={false}
        value={dietaryadvice}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice: value,
              plan,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.dietaryadvice ?? value;
          }
          if (errors.dietaryadvice?.hasError) {
            runValidationTasks("dietaryadvice", value);
          }
          setDietaryadvice(value);
        }}
        onBlur={() => runValidationTasks("dietaryadvice", dietaryadvice)}
        errorMessage={errors.dietaryadvice?.errorMessage}
        hasError={errors.dietaryadvice?.hasError}
        {...getOverrideProps(overrides, "dietaryadvice")}
      ></TextField>
      <SelectField
        label="Plan"
        placeholder="Please select an option"
        isDisabled={false}
        value={plan}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan: value,
              diettype,
            };
            const result = onChange(modelFields);
            value = result?.plan ?? value;
          }
          if (errors.plan?.hasError) {
            runValidationTasks("plan", value);
          }
          setPlan(value);
        }}
        onBlur={() => runValidationTasks("plan", plan)}
        errorMessage={errors.plan?.errorMessage}
        hasError={errors.plan?.hasError}
        {...getOverrideProps(overrides, "plan")}
      >
        <option
          children="Basic"
          value="BASIC"
          {...getOverrideProps(overrides, "planoption0")}
        ></option>
        <option
          children="Regular"
          value="REGULAR"
          {...getOverrideProps(overrides, "planoption1")}
        ></option>
        <option
          children="Advance"
          value="ADVANCE"
          {...getOverrideProps(overrides, "planoption2")}
        ></option>
        <option
          children="Premium"
          value="PREMIUM"
          {...getOverrideProps(overrides, "planoption3")}
        ></option>
      </SelectField>
      <SelectField
        label="Diettype"
        placeholder="Please select an option"
        isDisabled={false}
        value={diettype}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              email,
              name,
              dob,
              gender,
              height,
              company,
              mobile,
              dietstatus,
              diet,
              ptstatus,
              selfishsstatus,
              profile,
              breakfast,
              lunch,
              esnacks,
              dinner,
              dietaryadvice,
              plan,
              diettype: value,
            };
            const result = onChange(modelFields);
            value = result?.diettype ?? value;
          }
          if (errors.diettype?.hasError) {
            runValidationTasks("diettype", value);
          }
          setDiettype(value);
        }}
        onBlur={() => runValidationTasks("diettype", diettype)}
        errorMessage={errors.diettype?.errorMessage}
        hasError={errors.diettype?.hasError}
        {...getOverrideProps(overrides, "diettype")}
      >
        <option
          children="Traditional"
          value="TRADITIONAL"
          {...getOverrideProps(overrides, "diettypeoption0")}
        ></option>
        <option
          children="Vegan"
          value="VEGAN"
          {...getOverrideProps(overrides, "diettypeoption1")}
        ></option>
        <option
          children="Mediterranean"
          value="MEDITERRANEAN"
          {...getOverrideProps(overrides, "diettypeoption2")}
        ></option>
        <option
          children="Keto"
          value="KETO"
          {...getOverrideProps(overrides, "diettypeoption3")}
        ></option>
        <option
          children="Paleo"
          value="PALEO"
          {...getOverrideProps(overrides, "diettypeoption4")}
        ></option>
        <option
          children="Lowcarb"
          value="LOWCARB"
          {...getOverrideProps(overrides, "diettypeoption5")}
        ></option>
        <option
          children="Intermittent"
          value="INTERMITTENT"
          {...getOverrideProps(overrides, "diettypeoption6")}
        ></option>
        <option
          children="Glutenfree"
          value="GLUTENFREE"
          {...getOverrideProps(overrides, "diettypeoption7")}
        ></option>
        <option
          children="Dash"
          value="DASH"
          {...getOverrideProps(overrides, "diettypeoption8")}
        ></option>
        <option
          children="Flexitarian"
          value="FLEXITARIAN"
          {...getOverrideProps(overrides, "diettypeoption9")}
        ></option>
        <option
          children="Pescatarian"
          value="PESCATARIAN"
          {...getOverrideProps(overrides, "diettypeoption10")}
        ></option>
        <option
          children="Lactosefree"
          value="LACTOSEFREE"
          {...getOverrideProps(overrides, "diettypeoption11")}
        ></option>
        <option
          children="Vegetarian"
          value="VEGETARIAN"
          {...getOverrideProps(overrides, "diettypeoption12")}
        ></option>
      </SelectField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || userProfileModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || userProfileModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
